<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>VIEW -  STOCK MANAGEMENT</h2>
       <p>Stock details</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12">
       <div class="grid_view">
       <h3>&nbsp;</h3>
       <div class="card mt-0">
       <div class="card-body">
       <div class="row">
        <div class="col-lg-4 col-sm-4 col-12">
          <p><span class="blue">Farm Name:&nbsp;</span><span id="farmname" ></span></p>
          </div>
       <div class="col-lg-4 col-sm-4 col-12">
       <p><span class="blue">Species Name:&nbsp;</span><span id="Speciesname"></span></p>
       </div>
       <div class="col-lg-4 col-sm-4 col-12">
        <p><span class="blue">Breed Name:&nbsp;</span><span id="BreedName" ></span></p>
        </div>
        <div class="col-lg-4 col-sm-4 col-12">
          <p><span class="blue">Birth Date:&nbsp;</span><span id="birthdate" >{{birthdate | date:'dd/MM/yyyy'}}</span></p>
          </div>
          <div class="col-lg-4 col-sm-4 col-12">
            <p><span class="blue">Age Group:&nbsp;</span><span id="agetype" ></span></p>
            </div>
            <div class="col-lg-4 col-sm-4 col-12">
              <p><span class="blue">Animal ID:&nbsp;</span><span id="animalid" ></span></p>
              </div>
              <div class="col-lg-4 col-sm-4 col-12">
                <p><span class="blue">Gender:&nbsp;</span><span id="Gender" ></span></p>
                </div>
            <div class="col-lg-4 col-sm-4 col-12">
              <p><span class="blue">Weight (kg):&nbsp;</span><span id="getWeight" ></span></p>
              </div>
              <div class="col-lg-4 col-sm-4 col-12">
                <p><span class="blue">Date Of Transfer:&nbsp;</span><span id="transferdate" >{{transfdate | date:'dd/MM/yyyy'}}</span></p>
                </div>
                <div class="col-lg-4 col-sm-4 col-12">
                    <p><span class="blue">Date Of Purchase:&nbsp;</span><span id="purchasedate" >{{datepurchase| date:'dd/MM/yyyy'}}</span></p>
                    </div>
         <div class="col-lg-4 col-sm-4 col-12">
      <p><span class="blue">Date Of Deletion:&nbsp;</span><span id="deletedate" >{{datedelete | date:'dd/MM/yyyy'}}</span></p>
             </div>
        <div class="col-lg-4 col-sm-4 col-12">
          <p><span class="blue">Status:&nbsp;</span><span id="Status" ></span></p>
            </div>
       </div>
       </div>
       </div>
       </div>
       </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <button type="submit" (click)='stockmanagement()' class="btn btn-fill btn-primary mb-3">
        Back <div class="ripple-container"></div>
       </button>
       </div>
       </div>
     </div>
   </div>
 </div>
